export default __webpack_public_path__ + "static/media/Hangman4.66a15e84.svg";